import { Link } from "react-router-dom";
import { PawPrint, EnvelopeSimple } from "@phosphor-icons/react";
import { useI18n } from "@/context/I18nContext";
import { SUPPORT_EMAIL } from "@/constants/support";
import { resetConsent } from "@/lib/consent";

export default function Footer() {
    const { t } = useI18n();
    return (
        <footer className="hidden sm:block border-t border-paw-line dark:border-white/10 bg-paw-bone dark:bg-[hsl(152,15%,8%)]">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid gap-8 md:grid-cols-4">
                <div>
                    <div className="flex items-center gap-2 mb-3">
                        <span className="grid place-items-center w-8 h-8 rounded-full bg-paw-forest text-white">
                            <PawPrint size={18} weight="fill" />
                        </span>
                        <span className="font-display text-lg text-paw-ink dark:text-paw-bone notranslate" translate="no">PawLink</span>
                    </div>
                    <p className="text-sm text-paw-ink2 dark:text-paw-bone/60 max-w-sm">
                        {t("footer.trust1")} {t("footer.trust2")} {t("footer.trust3")}
                    </p>
                </div>
                <div>
                    <div className="text-sm font-semibold text-paw-ink dark:text-paw-bone mb-3">{t("footer.product")}</div>
                    <ul className="space-y-2 text-sm text-paw-ink2 dark:text-paw-bone/60">
                        <li><Link to="/subscription" className="hover:text-paw-ink dark:hover:text-paw-bone">{t("nav.protection")}</Link></li>
                        <li><Link to="/register" className="hover:text-paw-ink dark:hover:text-paw-bone">{t("footer.create_profile")}</Link></li>
                        <li><Link to="/login" className="hover:text-paw-ink dark:hover:text-paw-bone">{t("footer.sign_in")}</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="text-sm font-semibold text-paw-ink dark:text-paw-bone mb-3">{t("footer.support")}</div>
                    <ul className="space-y-2 text-sm text-paw-ink2 dark:text-paw-bone/60">
                        <li><Link to="/support" className="hover:text-paw-ink dark:hover:text-paw-bone">{t("footer.contact_us")}</Link></li>
                        <li><Link to="/faq" className="hover:text-paw-ink dark:hover:text-paw-bone">{t("footer.help_center")}</Link></li>
                        <li>
                            <Link
                                to="/support"
                                data-testid="footer-support-email"
                                className="inline-flex items-center gap-1.5 hover:text-paw-ink dark:hover:text-paw-bone break-all"
                                dir="ltr"
                            >
                                <EnvelopeSimple size={12} weight="fill" />
                                {SUPPORT_EMAIL}
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <div className="text-sm font-semibold text-paw-ink dark:text-paw-bone mb-3">{t("footer.trust")}</div>
                    <ul className="space-y-2 text-sm text-paw-ink2 dark:text-paw-bone/60">
                        <li><Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-paw-ink dark:hover:text-paw-bone">{t("legal.privacy_title")}</Link></li>
                        <li><Link to="/terms-of-use" data-testid="footer-terms" className="hover:text-paw-ink dark:hover:text-paw-bone">{t("legal.terms_title")}</Link></li>
                        <li>
                            <button
                                type="button"
                                onClick={resetConsent}
                                data-testid="footer-cookie-preferences"
                                className="hover:text-paw-ink dark:hover:text-paw-bone underline-offset-2"
                            >
                                Cookie preferences
                            </button>
                        </li>
                        <li><Link to="/refund-policy" data-testid="footer-refund" className="hover:text-paw-ink dark:hover:text-paw-bone">Refund Policy</Link></li>
                        <li><Link to="/delete-account" data-testid="footer-delete-account" className="hover:text-paw-ink dark:hover:text-paw-bone">Delete Account</Link></li>
                        <li>{t("footer.trust3")}</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-paw-line dark:border-white/10">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 text-xs text-paw-ink2 dark:text-paw-bone/50 flex flex-col md:flex-row justify-between gap-2">
                    <p>© {new Date().getFullYear()} PawLink. All rights reserved.</p>
                    <p>{t("footer.tag")}</p>
                </div>
            </div>
        </footer>
    );
}
